import jQuery from 'jquery';
var Parse = require('parse');


export const getFullPageCount = async () => {
    var EmailTemplates = Parse.Object.extend("EmailTemplates");
    var query = new Parse.Query(EmailTemplates);
    query.equalTo("status", true);
    query.descending("createdAt");
    const count = await query.count();

    return count;
}

export const getSearchResults = async (searchdatas) => {
    var EmailTemplates = Parse.Object.extend("EmailTemplates");
    var query = new Parse.Query(EmailTemplates);
    query.descending("createdAt");
    query.equalTo("status", true);

    if (searchdatas['searchbox']) {
        query.matches("name", searchdatas['searchbox'], 'i');
    }

    if (searchdatas['statsrc'] == "true") {
        query.equalTo("status", true);
    } else if (searchdatas['statsrc'] == "false") {
        query.equalTo("status", false);
    }
    return query.find().then((records) => {
        return records;
    }, (error) => {
    });

}

export const getEmailTemplates = async (pagenum, dataperpage, sortitem, sortitemorder) => {
    var skipnum = pagenum - 1;
    var perpage = parseInt(dataperpage);

    var EmailTemplates = Parse.Object.extend("EmailTemplates");
    var query = new Parse.Query(EmailTemplates);
    query.equalTo("status", true);

    if (sortitem !== "") {
        if (sortitemorder === "ascending") {
            query.ascending(sortitem);
        } else {
            query.descending(sortitem);
        }

    } else {
        query.descending('createdAt');
    }

    query.skip(skipnum * perpage);
    query.limit(perpage);

    return query.find().then((records) => {
        return records;
    }, (error) => {
    });
}

export const hideRecords = async (objectids) => {

    var parseobject = Parse.Object.extend("EmailTemplates");
    var query = new Parse.Query(parseobject);
    query.equalTo("objectId", objectids);
    return query.find().then((object) => {
        var realbject = object[0];
        realbject.set("status", false);
        return realbject.save().then((records) => {
            return true;
        }, (error) => {
            console.log(error);
        }).catch(function (error) {
        });

    }, (error) => {
    });


}


export const addRecord = async ({ name, subject, htmldata, toemail, status }) => {
    var EmailTemplates = new Parse.Object("EmailTemplates");

    EmailTemplates.set("name", name);
    EmailTemplates.set("subject", subject);
    EmailTemplates.set("html", htmldata);
    EmailTemplates.set("toEmail", toemail);
    if (status === 'false') {
        EmailTemplates.set("status", false);
    } else {
        EmailTemplates.set("status", true);
    }


    return EmailTemplates.save().then((EmailTemplates) => {
        return EmailTemplates;
    }, (error) => {
        return false;
    }).catch(function (error) {
        return false;
    });
}


export const fetchRecordById = async ({ objectid }) => {
    var EmailTemplates = Parse.Object.extend("EmailTemplates");
    var query = new Parse.Query(EmailTemplates);
    query.equalTo("objectId", objectid);
    return query.find().then((records) => {
        return records;
    }, (error) => {
        return false;
    }).catch(function (error) {
        return false;
    });
}


export const updateRecord = async ({ edithiddenid, name, subject, htmldata, toemail, status }) => {
    var EmailTemplates = Parse.Object.extend("EmailTemplates");
    var query = new Parse.Query(EmailTemplates);
    query.equalTo("objectId", edithiddenid);

    return query.find().then((object) => {

        var realbject = object[0];

        realbject.set("name", name);
        realbject.set("name", name);
        realbject.set("subject", subject);
        realbject.set("html", htmldata);
        realbject.set("toEmail", toemail);
        if (status === 'false') {
            realbject.set("status", false);
        } else {
            realbject.set("status", true);
        }

        return realbject.save().then((records) => {
            return true;
        }, (error) => {
            return false;
        }).catch(function (error) {
            return false;
        });

    }, (error) => {
        return false;
    });

}




export const checkFieldValid = (addoredit) => {

    var name = jQuery('#bname');
    var subject = jQuery('#subject');
    var htmldata = jQuery('#htmldata');

    var errstat = true;
    if (name.val() === "") {
        name.addClass("is-invalid");
        errstat = false;
    } else {
        name.removeClass("is-invalid");
    }
    if (subject.val() === "") {
        subject.addClass("is-invalid");
        errstat = false;
    } else {
        subject.removeClass("is-invalid");
    }
    if (htmldata.val() === "") {
        htmldata.addClass("is-invalid");
        errstat = false;
    } else {
        htmldata.removeClass("is-invalid");
    }



    if (errstat === false) {
        return false;
    } else {
        return true;
    }

}

